package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.Display.NONE
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.TextAlign.CENTER
import com.downdogapp.TextAlign.LEFT
import com.downdogapp.client.AppPage
import com.downdogapp.client.Strings
import com.downdogapp.client.View
import com.downdogapp.client.controllers.MessageViewController
import com.downdogapp.client.resources.Images
import com.downdogapp.client.resources.backgroundImage
import com.downdogapp.client.widget.*
import org.w3c.dom.*

actual class MessageView actual constructor(
  private val controller: MessageViewController
) : TopLevelView(), View {

  private val containerPadding = if (controller.message.displayFeedbackBox) px(30) else px(60)

  private lateinit var messageTitle: HTMLSpanElement
  private var messageContainer: HTMLDivElement? = null
  private var feedbackBox: HTMLTextAreaElement? = null
  private var submitButton: TextButton? = null
  private var cancelButton: HTMLDivElement? = null
  private var thanks: HTMLElement? = null

  override val root = createView()

  actual val feedback: String? get() = feedbackBox?.value

  override fun onBecameVisible() {
    feedbackBox?.focus()
  }

  private fun createView(): HTMLElement {
    val block: HTMLDivElement.() -> Unit = {
      centerInParent {
        width = px(400)
        bgColor = Color.BLACK

        if (!controller.blockOnBackClicked) {
          paddingTop = containerPadding
          paddingLeft = containerPadding
          paddingRight = containerPadding
          paddingBottom = px(10)
        } else {
          padding = containerPadding
        }

        borderRadius = CONTAINER_RADIUS

        div {
          marginBottom = px(20)
          textAlign = CENTER

          messageTitle = label(controller.message.title, 25, FontWeight.SEMIBOLD)
        }

        messageContainer = controller.message.content?.let {
          div {
            marginBottom = px(20)
            textAlign = if (controller.message.displayFeedbackBox) LEFT else CENTER

            label(
              text = "",
              fontSize = if (controller.message.displayFeedbackBox) 12 else 20
            ).apply {
              innerHTML = it.replace("\n", "<br>")
            }
          }
        }

        div {
          textAlign = CENTER

          if (controller.message.displayFeedbackBox) {
            thanks = label(Strings.THANKS, 23) {
              display = NONE
              opacity = 0.0
            }

            feedbackBox = customEditText {
              width = percent(100)
              height = px(300)
              padding = px(20)
              controller.message.feedbackHintText?.let {
                placeholder = it
              }
              fontSize = px(20)
            }

            submitButton = roundedTextButton(
              text = controller.message.continueButtonText ?: Strings.SEND,
              clickFn = {
                controller.submitClicked()
              }
            ) {
              marginTop = ROUNDED_TEXT_BUTTON_HEIGHT_PX / 2
            }
          }

          controller.message.link?.let { link ->
            roundedTextButton(
              text = link.label,
              clickFn = controller::linkClicked
            ) {
              marginTop = ROUNDED_TEXT_BUTTON_HEIGHT_PX / 2
            }
          }

          if (!controller.blockOnBackClicked) {
            cancelButton = settingsCancelButton(
              text = controller.message.continueButtonText
                     ?: if (controller.message.displayFeedbackBox || controller.message.link != null)
                       Strings.CANCEL
                     else
                       Strings.CONTINUE,
              clickFn = controller::onBackClicked
            )
          }
        }
      }
    }

    return controllerView {
      if (AppPage.displayingAboveStartView && !AppPage.displayingAbovePlayback) {
        bg = background(true)
        fg = foreground(true, block)
      } else {
        if (AppPage.getViewControllers().isEmpty()) {
          bg = background {
            backgroundImage = Images.LOGIN
            backgroundPosition = BackgroundPosition.CENTER
            backgroundSize = BackgroundSize.COVER
            backgroundRepeat = BackgroundRepeat.NO_REPEAT
          }
        }
        fg = foreground {
          block()
        }
      }
    }
  }

  actual fun feedbackSent() {
    feedbackBox?.readOnly = true
    messageContainer?.opacity = 0.0
    cancelButton?.opacity = 0.0
    feedbackBox?.opacity = 0.0
    submitButton?.hide()
    thanks?.fadeIn(duration = seconds(0.3))
  }

  companion object {

    val CONTAINER_RADIUS = px(10)
  }
}
